import { render, staticRenderFns } from "./JobPositions.vue?vue&type=template&id=2afa4200&"
import script from "./JobPositions.vue?vue&type=script&lang=js&"
export * from "./JobPositions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports